/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HistoryHttpService } from './http.history.service';

@Injectable()
export class HistoryInterceptor implements HttpInterceptor {
  constructor(private historyHttpService: HistoryHttpService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.historyHttpService.handleApiRequest(request);
    return next.handle(request);
  }
}
